import React from "react";
import {DashboardCard} from "../../../../designSystem/components/DashboardCard";
import {Typography} from "../../../../designSystem/components/Typography";
import {InformationTable} from "../InformationTable";
import {InformationRow} from "../InformationRow";
import {ICase} from "../../../../types/Case";
import {SERVICE_CHECK_ITEMS_MAPPING} from "../../../../utils/constants";

interface ApplicationInformationViewProps {
  caseData: ICase;
}

export const ApplicationInformationView = ({
  caseData
}: ApplicationInformationViewProps) => (
  <DashboardCard>
    <Typography variant="subtitle">
      案件資訊
    </Typography>
    <InformationTable>
      {Object.keys(SERVICE_CHECK_ITEMS_MAPPING).map(key => {
        if (key in caseData) {
          return (
            <InformationRow
              title={SERVICE_CHECK_ITEMS_MAPPING[key]}
              value={caseData[key] ? '是' : '否'}
            />
          )
        }
        return null
      })}
      {'distressDescription' in caseData &&
        <InformationRow
          title="個案心理困擾描述"
          value={caseData.distressDescription}
        />
      }
      {'reasonMobilePharmacist' in caseData &&
        <InformationRow
          title="詳述原因"
          value={caseData.reasonMobilePharmacist}
        />
      }
    </InformationTable>
  </DashboardCard>
)
